import { render, staticRenderFns } from "./FaPiaoInfo.vue?vue&type=template&id=98272402&scoped=true"
import script from "./FaPiaoInfo.vue?vue&type=script&lang=js"
export * from "./FaPiaoInfo.vue?vue&type=script&lang=js"
import style0 from "./FaPiaoInfo.vue?vue&type=style&index=0&id=98272402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98272402",
  null
  
)

export default component.exports